import React from "react";
import Header from "../components/layout/Header";
import { Sidebar } from "../components/layout/Sidebar";
import { PageWrapper } from "../components/layout/PageWrapper";
import { TopBar } from "../components/common/TopBar";
import CompanyCardsGrid from "../components/company/CompanyCardsGrid";
import { useThemeToggle } from "../hooks/useThemeToggle";
import { Link } from "react-router-dom";

export default function AdminCompanyCards() {
useThemeToggle();
return (
<div className="main-wrapper">
<Header />
<Sidebar />
<PageWrapper>
{/* Top Bar (exact classes preserved); 'cards' view is active */}
<div className="top-bar">
<Link to="/admin/add-new-company" className="btn btn-turquoise">
<i className="fa-solid fa-plus"></i> Add New Company
</Link>
<div>
<Link to="/admin/company-card-view-list" className="actives me-3">
<i className="fa-solid fa-bars fa-lg"></i>
</Link>
<Link to="/admin/company-list" className="">
<i className="fa-solid fa-th-large fa-lg"></i>
</Link>
</div>
</div>


{/* Card grid */}
<CompanyCardsGrid />
</PageWrapper>
</div>
);
}